/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum APITicketStatusEnum {
    Open = 'Open',
    In_Progress = 'In Progress',
    Feedback = 'Feedback',
    Closed = 'Closed'
}


export function instanceOfAPITicketStatusEnum(value: any): boolean {
    for (const key in APITicketStatusEnum) {
        if (Object.prototype.hasOwnProperty.call(APITicketStatusEnum, key)) {
            if (APITicketStatusEnum[key as keyof typeof APITicketStatusEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function APITicketStatusEnumFromJSON(json: any): APITicketStatusEnum {
    return APITicketStatusEnumFromJSONTyped(json, false);
}

export function APITicketStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): APITicketStatusEnum {
    return json as APITicketStatusEnum;
}

export function APITicketStatusEnumToJSON(value?: APITicketStatusEnum | null): any {
    return value as any;
}

